module.exports = __webpack_public_path__ + "img/主页图片1.b53cc0e1.png";